import { AWSFeatureStatus } from "@doitintl/cmp-models";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Chip, type ChipProps, Tooltip } from "@mui/material";

const getStatusLabel = (status: AWSFeatureStatus): string => {
  switch (status) {
    case AWSFeatureStatus.Enabled:
      return "Enabled";
    case AWSFeatureStatus.PartiallyEnabled:
      return "Partially enabled";
    default:
      return "Unknown";
  }
};

const getStatusColor = (status: AWSFeatureStatus): ChipProps["color"] => {
  switch (status) {
    case AWSFeatureStatus.Enabled:
      return "success";
    case AWSFeatureStatus.PartiallyEnabled:
      return "info";
    default:
      return "default";
  }
};

type FeaturesStatusChipProps = {
  status: AWSFeatureStatus;
};

export const FeaturesStatusChip = ({ status }: FeaturesStatusChipProps) => {
  const label = getStatusLabel(status);
  const color = getStatusColor(status);

  if (status === AWSFeatureStatus.PartiallyEnabled) {
    const formattedLabel = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();

    return (
      <Chip
        variant="status"
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <span style={{ textTransform: "none" }}>{formattedLabel}</span>
            <Tooltip title="New permissions available for full feature access">
              <InfoOutlinedIcon sx={{ fontSize: 16 }} />
            </Tooltip>
          </Box>
        }
        color={color}
      />
    );
  }

  return <Chip variant="status" label={label} color={color} />;
};
